import {
  RECEIVE_AB_TEST_DETAILS,
  RECEIVE_DASHBOARD,
  RECEIVE_CHART_DATA,
  RECEIVE_ERROR,
  DISMISS_ALERT,
} from '../actions/shipAbTestDashboardAnalyticsActions';

const initialState = {
  chartData: {},
  dimensions: [],
  errors: [],
  dashboard: {},
  object: '',
  reports: {},
  reportDefinitions: {},
  reportsPayload: [],
  alert: {
    show: false,
  },
  abTestDetails: {},
};

export default (
  state = initialState,
  {
    type,
    meta,
    meta: { chartName } = {},
    payload: {
      status,
      createdBy,
      createdDate,
      startDate,
      endDate,
      chartData,
      tableData,
      report_definitions: reportDefinitions,
      report_instances: reportInstances,
      dashboard_definitions: dashboard,
    } = {},
  } = {},
) => {
  let object;
  switch (type) {
    case RECEIVE_AB_TEST_DETAILS:
      return {
        ...state,
        abTestDetails: {
          status,
          createdBy,
          createdDate,
          startDate,
          endDate,
        },
      };
    case RECEIVE_DASHBOARD:
      object = Object.keys(reportDefinitions)[0];
      return {
        ...state,
        dashboard,
        object,
        reports: {
          ...state.reports,
          ...reportInstances,
        },
        reportDefinitions,
      };
    case RECEIVE_CHART_DATA:
      return {
        ...state,
        chartData: {
          ...state.chartData,
          [chartName]: chartData,
        },
        tableData: {
          ...state.tableData,
          [chartName]: tableData,
        },
      };
    case RECEIVE_ERROR:
      return {
        ...state,
        alert: {
          color: 'danger',
          show: true,
          text:
            typeof meta.error !== 'string'
              ? 'Unknown error occured.'
              : `${meta.error}.`,
        },
      };
    case DISMISS_ALERT:
      return {
        ...state,
        alert: initialState.alert,
      };
    default:
      return state;
  }
};
